import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from "moment";

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  beforeCreate() {
    moment.locale('zh-cn');//全局使用moment.js,使用时示例:`this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')`
    Vue.prototype.$moment = moment;
  },
  render: h => h(App),
}).$mount('#app')
